import React, { Component } from 'react';
import Filler from '../../../utility_components/Filler';
import {RadixBadge} from "../../../ui/primitives/RadixBadge";

export default class ItemCard extends Component {
    constructor(props) {
        super(props);
        this.navigate = this.navigate.bind(this);
        this.state = {
            imageIsValid: true
        };
        this.setInvalidImage = this.setInvalidImage.bind(this);
    }

    navigate() {
        if(!this.props.navigationLink || this.props.navigationFunctionOverride) {
            if(this.props.navigationFunctionOverride) {
                this.props.navigationFunctionOverride();
            }else {
                throw new Error("Call to action link required");
            }
        }else {
            document.location = this.props.navigationLink;
        }
    };

    setInvalidImage() {
        this.setState({imageIsValid: false});
    }

    render() {
        return (
            !window.session.store.image_light ?
                <div className="card mt-1 mb-1">
                    {this.props.imageUrl &&
                    this.state.imageIsValid ?
                        <div>
                            <img onError={this.setInvalidImage} onClick={this.navigate}
                                 className='clickable-element card-img-top card-img image'
                         src={this.props.imageUrl} alt={this.props.label}
                    />
                    <div className="overlay" onClick={this.navigate}>
                        {this.props.label}
                    </div>
                    </div>
                    :
                    !this.props.isSpecialCard ?
                    <div className="media" onClick={this.navigate}>
                        {this.props.imageUrl ?
                            <img src={this.props.imageUrl} className="mr-3" height={64} width={64} alt="Menu Image" />
                            :
                            <div style={{height: 64,width: 64}} className={"mr-3 text-center"}>
                                <i className="fas fa-utensils text-branded h1 mt-2" aria-hidden="true"></i>
                            </div>
                        }
                        <div className="media-body">
                            <div className={"row"}>
                                <div className={"col-10"}>
                                    <h5 className={`m-3`}>{this.props.label}</h5>
                                </div>
                                <div className={"col-2"}>
                                    <i className="fas fa-chevron-circle-right text-branded h5 mt-3"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    //    todo replace this with image light version for specials.
                    <div>
                        <Filler navigationFunction={this.navigate}/>
                        <div className="overlay">{this.props.label}</div>
                    </div>
                }
            </div>
            :
            <div className="card h-100">
                <div className="row g-0">
                    <div className="col-md-12">
                        <div className="card-body">
                            <div className={"row"}>
                                <div className={"col-12"}>
                                    <h5 className="card-title font-weight-bold p-0 m-0 mb-1 text-wrap">{this.props.label}</h5>
                                    {this.props.description ? <hr /> : null}
                                    <p className="card-text text-secondary"><i>{this.props.description}</i></p>
                                    <br/>
                                    <div>
                                        <button onClick={this.navigate} className={"btn btn-danger"}>Order Now</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
